













import { defineComponent } from "@vue/composition-api";
import { Message } from "@scrile/api-provider/dist/api/MessagesProvider";
import providers from "@/lib/api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "MessageDeleteConfirm",
  components: { BaseConfirm, BaseButton },
  props: { message: { type: Object as () => Message } },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async deleteMessage() {
      if (!this.message) {
        return;
      }
      try {
        this.loading = true;
        await providers.MessagesProvider.delete({ id: this.message.id });
        this.$emit("deleted");
      } finally {
        this.loading = false;
      }
    },
  },
});
